import {create} from 'zustand';
import {SUBSCRIPTION_DIALOGS_DEFAULT_STATE} from './constants';
import {SubscriptionDialogsStateStore} from './types';

export const useSubscriptionDialogsStateStore = create<SubscriptionDialogsStateStore>(
	(set, get) => ({
		state: SUBSCRIPTION_DIALOGS_DEFAULT_STATE,
		updateState: partial =>
			set({
				state: {
					...get().state,
					...partial,
				},
			}),
		reset: () => set({state: SUBSCRIPTION_DIALOGS_DEFAULT_STATE}),
	}),
);
